var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_460_1239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3027 1.875H3.55273C2.86238 1.875 2.30273 2.43464 2.30273 3.125V11.875C2.30273 12.5654 2.86238 13.125 3.55273 13.125H12.3027C12.9931 13.125 13.5527 12.5654 13.5527 11.875V3.125C13.5527 2.43464 12.9931 1.875 12.3027 1.875Z",
    stroke: "#979797",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.74023 6.25C6.258 6.25 6.67773 5.83027 6.67773 5.3125C6.67773 4.79473 6.258 4.375 5.74023 4.375C5.22247 4.375 4.80273 4.79473 4.80273 5.3125C4.80273 5.83027 5.22247 6.25 5.74023 6.25Z",
    stroke: "#979797",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5527 9.375L10.4277 6.25L3.55273 13.125",
    stroke: "#979797",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_460_1239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(15.4277) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIc);
export default __webpack_public_path__ + "static/media/image_ic.49f0a8b7ec96edfeca8701b350c627e4.svg";
export { ForwardRef as ReactComponent };